import Swal from 'sweetalert2'

class DisallowedLocations {
  constructor( settings ) {
    this.lists = settings.lists
    this.csrf = settings.csrf
    this.init()
  }

  init () {
    this.cacheDOM()
    this.bindEvents()
    this.initDatatable()
    this.initFormSubmission()
  }

  cacheDOM () {
    this.$disallowed_locations = $( "#disallowed-locations-table" )
    this.$body = $( "body" )
  }

  bindEvents () {
    $( "body" ).on( "click", ".delete-location", this.deleteLocation.bind( this ) )
  }

  deleteLocation ( e ) {
    e.preventDefault()
    const _SELF = this,
      TARGET = $( e.currentTarget )

    Swal.fire( {
      title: "Are you sure?",
      text: "You will not be able to recover!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    } ).then( result => {
      if ( result.isConfirmed ) {
        $.ajax( {
          url: TARGET.data( "url" ),
          type: "DELETE",
          dataType: "json",
          cache: false,
          processData: false,
          headers: {'X-CSRF-TOKEN': _SELF.csrf},
          success: function ( response, textStatus, xhr ) {
            _SELF.$table.draw()

            toastr.success(
              "Location has been Successfully deleted",
              "",
              {
                timeOut: 30000,
                extendedTImeout: "1000"
              }
            )
          },
          error: function ( data ) {
            let responseJSON = data.responseJSON

            toastr.error( responseJSON.message, "", {
              timeOut: 30000,
              extendedTImeout: "1000"
            } )
          }
        } )
      }

      Swal.close()
    } )
  }

  initDatatable () {
    const SELF = this

    this.$table = this.$disallowed_locations.DataTable( {
      ajax: {
        url: SELF.lists,
        data: function ( data ) {
          data._method = "PATCH"
          $( ".filters input, .filters select" ).each( function () {
            let name = $( this ).attr( "name" ),
              value =
                $( this ).attr( "type" ) == "checkbox"
                  ? $( this ).is( ":checked" )
                    ? $( this ).val()
                    : 0
                  : $( this ).val()

            data[ name ] = value
          } )
        },
      },
      columns: [
        {
          data: "id",
        },
        {
          data: "location",
        },
        {
          data: "reason",
        },
        {
          data: "id",
          render: function ( data, type, row ) {
            return `<a class="btn btn-sm btn-danger delete-location" href="" data-url="/settings/restricted/${ row.id }/delete"><i class="fa fa-trash" aria-hidden="true"></i>
</a>`
          },
        }
      ],
      columnDefs: [
        {
          visible: false,
          targets: [ 0 ],
        },
        {
          orderable: false,
          targets: [ 3 ],
        },
      ],
      destroy: true,
      orderable: true,
      lengthMenu: [ 10, 20, 50, 100, 200, 500 ],
      orderCellsTop: true,
      paging: true,
      processing: true,
      searching: false,
      serverSide: true,
      stateSave: false,
      stripeClasses: [],
      pageLength: 10,
      sorting: [ [ 0, "desc" ] ],
    } )
  }

  initFormSubmission () {
    const FORM = $( "body" )
      .find( "#location-form" ),
      _SELF = this
    var validator = FORM.validate( {
      submitHandler: function ( form ) {
        $.ajax( {
          url: FORM.attr( "action" ),
          type: "POST",
          dataType: "json",
          data: FORM.serialize(),
          cache: false,
          processData: false,
          beforeSend: function () {
            FORM.find( "button[type='submit']" )
              .html(
                `<span style="margin-bottom: 5px" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Submitting....`
              )
              .prop( "disabled", true )
          },
          complete: function () {
            FORM.find( "button[type='submit']" )
              .html( `Save` )
              .prop( "disabled", false )
          },
          success: function ( response ) {
            toastr.success( response.message, "", {
              timeOut: 30000,
              extendedTImeout: "1000",
            } )

            $( "#form-modal" ).modal( 'hide' )
            _SELF.$table.draw()

          },
          error: function ( data ) {
            let responseJSON = data.responseJSON
            FORM.find( "button[type='submit']" )
              .html( `Save` )
              .prop( "disabled", false )

            if ( data.status == 422 ) {
              let err = {}

              $.each(
                responseJSON.errors,
                function ( i, v ) {
                  err[ i ] = v
                }
              )

              validator.showErrors( err )

              $( "html, body" ).animate( {
                scrollTop: $(
                  validator.errorList[ 0 ].element
                ).offset().top,
              } )
            } else if (
              data.status == 423 ||
              data.status == 500
            ) {

            } else if ( data.status == 404 ) {

            }
          },
        } )

        return false
      },
    } )
  }
}

window.DisallowedLocations = DisallowedLocations
